var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 357,
    viewBox: "0 0 1737 357",
    width: 1737,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528.617 72.7266H452V263.586H486.9V194.059H527.526C567.334 194.059 592.418 170.065 592.418 133.256C592.418 97.5384 567.879 72.7266 528.617 72.7266ZM523.981 162.703H486.9V104.082H524.799C544.158 104.082 555.61 115.534 555.61 133.256C555.61 150.979 544.976 162.703 523.981 162.703Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M616.197 263.587H651.097V200.058C651.097 180.427 659.004 158.341 688.996 158.341C693.904 158.341 698.812 158.614 703.72 159.432V124.532H693.904C671.001 124.532 661.731 132.985 653.278 146.617H651.097L647.825 127.259H616.197V263.587Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M786.341 266.314C827.513 266.314 858.323 237.412 858.323 195.15C858.323 153.434 827.24 124.532 786.341 124.532C745.443 124.532 714.36 153.161 714.36 195.15C714.36 237.139 745.716 266.314 786.341 266.314ZM786.341 236.049C763.984 236.049 749.26 218.053 749.26 195.15C749.26 172.52 763.984 154.797 786.341 154.797C808.699 154.797 823.696 172.52 823.696 195.15C823.696 218.053 808.972 236.049 786.341 236.049Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M883.529 263.587H918.429V182.608C918.429 163.795 930.699 154.797 943.241 154.797C956.328 154.797 966.417 164.067 966.417 182.063V263.587H1001.32V182.881C1001.32 165.703 1011.4 154.797 1026.13 154.797C1039.22 154.797 1049.58 163.522 1049.58 180.972V263.587H1084.48V174.428C1084.48 141.437 1066.48 124.532 1038.4 124.532C1015.22 124.532 1003.22 135.439 995.864 146.072H993.682C989.047 136.257 979.504 124.532 957.964 124.532C939.424 124.532 927.972 133.257 920.61 143.345H918.429L915.43 127.259H883.529V263.587Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.08 124.532C1167.81 124.532 1155 134.621 1148.45 143.345H1146L1143 127.259H1114.64V318.119H1149.54V250.772C1156.91 258.952 1170.54 266.314 1189.08 266.314C1224.8 266.314 1253.15 240.139 1253.15 195.695C1253.15 152.343 1225.62 124.532 1189.08 124.532ZM1183.63 236.049C1162.9 236.049 1149.54 219.689 1149.54 195.695C1149.54 171.156 1162.9 154.797 1183.63 154.797C1204.35 154.797 1218.25 171.156 1218.25 195.695C1218.25 219.689 1204.35 236.049 1183.63 236.049Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.75 266.314C1345.56 266.314 1353.74 264.678 1359.74 263.314V236.867C1355.65 237.957 1350.47 238.775 1346.38 238.775C1330.02 238.775 1328.11 229.505 1328.11 221.871V154.797H1363.83V127.258H1328.11V90.1768H1296.48V106.536C1296.48 121.26 1289.94 127.258 1273.31 127.258H1264.04V154.797H1293.21V226.506C1293.21 241.502 1297.57 266.314 1335.75 266.314Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.87 72.7266H1389.25V263.586H1424.16V194.059H1464.78C1504.59 194.059 1529.67 170.065 1529.67 133.256C1529.67 97.5384 1505.13 72.7266 1465.87 72.7266ZM1461.24 162.703H1424.16V104.082H1462.05C1481.41 104.082 1492.86 115.534 1492.86 133.256C1492.86 150.979 1482.23 162.703 1461.24 162.703Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.09 237.412C1671.55 237.412 1668.28 234.14 1668.28 227.051V177.155C1668.28 140.619 1642.38 124.532 1610.48 124.532C1575.58 124.532 1553.76 144.436 1551.04 172.792H1585.94C1588.12 160.523 1595.75 152.343 1610.48 152.343C1623.84 152.343 1633.38 159.705 1633.38 174.701V180.427L1590.84 184.789C1565.76 187.243 1545.86 200.058 1545.86 226.233C1545.86 253.226 1566.31 266.314 1594.12 266.314C1615.66 266.314 1629.83 258.952 1639.1 247.228C1643.74 259.77 1653.83 263.587 1666.64 263.587H1681.37V237.412H1678.09ZM1633.38 210.964C1633.38 232.504 1614.84 239.593 1600.11 239.593C1589.21 239.593 1580.76 235.776 1580.76 224.87C1580.76 214.236 1590.3 209.056 1602.84 207.692L1633.38 204.421V210.964Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1702.03 263.586H1736.93V70H1702.03V263.586Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.175 163.921L188.976 0H167.373L178.175 163.921Z",
    fill: "#E55733"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.175 192.429L188.976 356.35H167.373L178.175 192.429Z",
    fill: "#E55733"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.175 192.429L167.373 356.35H188.976L178.175 192.429Z",
    fill: "#E55733"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.175 163.921L167.373 0H188.976L178.175 163.921Z",
    fill: "#E55733"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.429 178.175L356.35 188.976V167.373L192.429 178.175Z",
    fill: "#E55733"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.921 178.175L0 188.976L9.44277e-07 167.373L163.921 178.175Z",
    fill: "#E55733"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.921 178.175L9.44277e-07 167.373L0 188.976L163.921 178.175Z",
    fill: "#E55733"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.429 178.175L356.35 167.373V188.976L192.429 178.175Z",
    fill: "#E55733"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.096 168.096L59.8238 44.5485L44.5485 59.8238L168.096 168.096Z",
    fill: "#E55733"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.254 188.254L311.801 296.526L296.526 311.801L188.254 188.254Z",
    fill: "#E55733"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M188.254 188.254L296.526 311.801L311.801 296.526L188.254 188.254Z",
    fill: "#E55733"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M168.096 168.096L44.5485 59.8238L59.8238 44.5485L168.096 168.096Z",
    fill: "#E55733"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M188.254 168.096L311.801 59.8239L296.526 44.5486L188.254 168.096Z",
    fill: "#E55733"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.096 188.254L59.8238 311.801L44.5485 296.526L168.096 188.254Z",
    fill: "#E55733"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168.096 188.254L44.5485 296.526L59.8238 311.801L168.096 188.254Z",
    fill: "#E55733"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M188.254 168.096L296.526 44.5486L311.801 59.8239L188.254 168.096Z",
    fill: "#E55733"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M181.864 164.406L234.723 8.86671L213.857 3.27556L181.864 164.406Z",
    fill: "#E55733"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M174.486 191.943L142.493 353.074L121.627 347.483L174.486 191.943Z",
    fill: "#E55733"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.486 191.943L121.627 347.483L142.493 353.074L174.486 191.943Z",
    fill: "#E55733"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M181.864 164.406L213.857 3.27556L234.723 8.86671L181.864 164.406Z",
    fill: "#E55733"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M191.943 181.864L347.483 234.723L353.074 213.857L191.943 181.864Z",
    fill: "#E55733"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M164.406 174.486L3.27559 142.493L8.86674 121.626L164.406 174.486Z",
    fill: "#E55733"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M164.406 174.486L8.86674 121.626L3.27559 142.493L164.406 174.486Z",
    fill: "#E55733"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M191.943 181.864L353.074 213.857L347.483 234.723L191.943 181.864Z",
    fill: "#E55733"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M171.048 165.83L98.4416 18.4703L79.7332 29.2716L171.048 165.83Z",
    fill: "#E55733"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M185.302 190.519L276.616 327.078L257.908 337.879L185.302 190.519Z",
    fill: "#E55733"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M185.302 190.519L257.908 337.879L276.616 327.078L185.302 190.519Z",
    fill: "#E55733"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M171.048 165.83L79.7332 29.2716L98.4416 18.4703L171.048 165.83Z",
    fill: "#E55733"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M190.519 171.048L337.879 98.4416L327.078 79.7332L190.519 171.048Z",
    fill: "#E55733"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M165.83 185.302L29.2715 276.616L18.4703 257.908L165.83 185.302Z",
    fill: "#E55733"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M165.83 185.302L18.4703 257.908L29.2715 276.616L165.83 185.302Z",
    fill: "#E55733"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M190.519 171.048L327.078 79.7332L337.879 98.4416L190.519 171.048Z",
    fill: "#E55733"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M185.302 165.83L276.616 29.2715L257.908 18.4702L185.302 165.83Z",
    fill: "#E55733"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M171.048 190.519L98.4416 337.879L79.7332 327.078L171.048 190.519Z",
    fill: "#E55733"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.048 190.519L79.7332 327.078L98.4416 337.879L171.048 190.519Z",
    fill: "#E55733"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M185.302 165.83L257.908 18.4702L276.616 29.2715L185.302 165.83Z",
    fill: "#E55733"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M190.519 185.302L327.078 276.616L337.879 257.908L190.519 185.302Z",
    fill: "#E55733"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M165.83 171.048L18.4703 98.4415L29.2715 79.7332L165.83 171.048Z",
    fill: "#E55733"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M165.83 171.048L29.2715 79.7332L18.4703 98.4415L165.83 171.048Z",
    fill: "#E55733"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M190.519 185.302L337.879 257.908L327.078 276.616L190.519 185.302Z",
    fill: "#E55733"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M174.486 164.407L142.493 3.27565L121.627 8.86679L174.486 164.407Z",
    fill: "#E55733"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M181.864 191.943L234.723 347.483L213.857 353.074L181.864 191.943Z",
    fill: "#E55733"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M181.864 191.943L213.857 353.074L234.723 347.483L181.864 191.943Z",
    fill: "#E55733"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.486 164.407L121.627 8.86679L142.493 3.27565L174.486 164.407Z",
    fill: "#E55733"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M191.943 174.486L353.074 142.493L347.483 121.626L191.943 174.486Z",
    fill: "#E55733"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M164.406 181.864L8.86675 234.723L3.2756 213.857L164.406 181.864Z",
    fill: "#E55733"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M164.406 181.864L3.2756 213.857L8.86675 234.723L164.406 181.864Z",
    fill: "#E55733"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M191.943 174.486L347.483 121.626L353.074 142.493L191.943 174.486Z",
    fill: "#E55733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.086bbad5856daa00cc07ecf5129abf48.svg";
export { ForwardRef as ReactComponent };